import ClientOrderRoutes from './modules/ClientOrderRoutes'

export default [
  ...ClientOrderRoutes
]